import React from "react";
import Link from "next/link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material";

import { NSApps } from "../../types";
import { neutral } from "../../../../common/config/colors";

const BannerItem: React.FC<NSApps.IBannerItem & { idx: number }> = ({
  title,
  sub_title,
  mobile_background_img,
  desktop_background_img,
  cta_link,
  cta_name,
  idx,
}) => {
  const theme = useTheme();

  return (
    <Link href={cta_link}>
      <a>
        <Box
          sx={{
            position: "relative",
            backgroundImage: `url(${desktop_background_img})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: { xs: 329, md: 387 },
            borderRadius: 5,
            [theme.breakpoints.down("md")]: {
              backgroundImage: `url(${mobile_background_img})`,
            },
          }}
        >
          <Grid
            container
            alignItems="center"
            sx={{ height: "100%", px: { xs: 9, md: 18 } }}
          >
            <Grid item xs={12} md={8}>
              <Typography
                /**
                 * We are adding variant conditionally because
                 * on each page there should be only one h1 tag
                 * */
                variant={idx === 0 ? "h1" : "h2"}
                sx={{
                  fontSize: { xs: 24, md: 36 },
                  color: neutral["A500"],
                  pb: { xs: 3, md: 4 },
                }}
              >
                {title}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: 16, md: 18 },
                  color: neutral["A500"],
                  pb: 6,
                }}
              >
                {sub_title}
              </Typography>
              <Button
                variant="contained"
                sx={{
                  fontSize: { xs: 14, md: 16 },
                  background: neutral[900],
                  borderRadius: 2.5,
                  "&:hover": {
                    background: neutral[900],
                  },
                }}
              >
                {cta_name}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </a>
    </Link>
  );
};

export default BannerItem;
